import React from 'react'
import { t } from 'ttag'

import { DetailsCard } from 'components/shared/DetailsCard/DetailsCard'

export const DefaultDescription = () => (
  <React.Fragment>
    <DetailsCard.Text>
      {t`For a competency-based interview, select the competencies that are most relevant to the job requirements.`}
    </DetailsCard.Text>
    <DetailsCard.Text>
      {t`Competencies are specific skills, knowledge and abilities that are required to perform a particular job. They are related to, but not the same as, personality traits. While personality traits refer to more stable patterns of behaviour over time, competencies reflect what a person is capable of in more specific work-related situations.`}
    </DetailsCard.Text>
    <DetailsCard.Text>
      {t`Each competency from our framework is connected to several interview questions developed to elicit specific examples of the candidate’s experiences and behaviours that demonstrate the competency. The interview questions are designed to be open-ended so that the candidate can provide a detailed answer. This will allow the interviewer to assess the candidate’scompetencies more accurately.`}
    </DetailsCard.Text>
  </React.Fragment>
)
